import { analytics } from '@/shared/services/analytics'
import { defineStore } from 'pinia'
import { ref } from 'vue'

export enum ToastType {
  Default = 'default',
  Success = 'success',
  Warning = 'warning',
  Error = 'error',
}

interface Toast {
  type: ToastType
  content: string
  timeout?: number
  error?: Error
}

export const useToastStore = defineStore('toast', () => {
  const state = ref<Toast | null>(null)
  let timer: ReturnType<typeof setTimeout>

  const showToast = (data: Toast) => {
    clearTimeout(timer)

    state.value = data

    timer = setTimeout(hideToast, data.timeout || 3000)

    if (data.error) {
      analytics.captureException(data.error)
    }
  }

  const hideToast = () => {
    state.value = null
  }

  return {
    state,
    showToast,
    hideToast,
  }
})
